import { DotsSixVerticalIcon } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';

interface ReportEventDragIndicatorProps {
    label: string;
    testId?: string;
    // The dragged card leaves the pointer behind, so CSS hover no longer
    // matches the card the indicator sits on.
    alwaysVisible?: boolean;
}

export function ReportEventDragIndicator({
    label,
    testId,
    alwaysVisible = false,
}: ReportEventDragIndicatorProps) {
    return (
        <span
            aria-hidden
            title={label}
            data-testid={testId}
            className={cn(
                'flex cursor-grab items-center justify-center rounded-[4px] p-1',
                'bg-black/40 text-white-100 backdrop-blur-[20px]',
                alwaysVisible
                    ? 'opacity-100'
                    : 'opacity-0 transition-opacity group-hover/report-event:opacity-100',
            )}
        >
            <DotsSixVerticalIcon className="h-4 w-4" weight="bold" />
        </span>
    );
}
